import { CommonModule, registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppMaterialModule } from './app-material.module';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { SearchDropdownComponent } from './components/search-dropdown/search-dropdown.component';
import { FilesModalComponent } from './components/files-modal/files-modal.component';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { TableauDialogComponent } from './components/tableau-dialog/tableau-dialog.component';
import { OtpInputComponent } from './components/opt-input/otp-input.component';

import { SlugifyPipe } from './pipes/slugify.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { DriveThumbnailPipe } from './pipes/drive-thumbnail.pipe';

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    RouterModule,
  ],
  exports: [
    DropdownComponent,
    SearchDropdownComponent,
    ProgressSpinnerComponent,
    AppMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    SlugifyPipe,
    DriveThumbnailPipe,
    FontAwesomeModule,
    OtpInputComponent,
  ],
  declarations: [
    DropdownComponent,
    SearchDropdownComponent,
    ProgressSpinnerComponent,
    SlugifyPipe,
    DriveThumbnailPipe,
    TableauDialogComponent,
    OtpInputComponent,
    FilesModalComponent,
  ],
  providers: [SlugifyPipe, DriveThumbnailPipe],
  entryComponents: [
    TableauDialogComponent,
    OtpInputComponent,
    FilesModalComponent,
  ],
})
export class SharedModule {}
